import { render, staticRenderFns } from "./personVerify.vue?vue&type=template&id=56645fd2&scoped=true"
import script from "./personVerify.vue?vue&type=script&lang=js"
export * from "./personVerify.vue?vue&type=script&lang=js"
import style0 from "./personVerify.vue?vue&type=style&index=0&id=56645fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56645fd2",
  null
  
)

export default component.exports